import type { ReactNode } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import {
  selectCockpitSwitchingOnOffering,
  selectIsCockpitOfferingSwitchedOff,
} from '../../../../model/selectors'
import { CockpitEmptyState } from '../../../components/cockpitEmptyState/CockpitEmptyState'

interface IAttentionSwitchedOffProps {
  children: ReactNode
}

/**
 * What needs attention for a programme switched off for the partner. Its statuses are not
 * calculated, so the card says so instead of listing them; the switch back on stands in the plan
 * deck over the board. While it is being switched on the board carries the loader, so the card
 * shows through.
 */
export const AttentionSwitchedOff = ({ children }: IAttentionSwitchedOffProps) => {
  const isSwitchedOff = useSelector(selectIsCockpitOfferingSwitchedOff)
  const switchingOnOffering = useSelector(selectCockpitSwitchingOnOffering)

  if (!isSwitchedOff || switchingOnOffering) {
    return <>{children}</>
  }

  return (
    <CockpitEmptyState
      title={
        <Translation text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.attentionStatuses.switchedOff} span />
      }
    />
  )
}

AttentionSwitchedOff.displayName = 'AttentionSwitchedOff'
